export const COLUMNS = {
  NAME: 'name',
  CATEGORY: 'category',
  TOTAL: 'total',
  SKU: 'sku',
  SUB_CATEGORY: 'subCategory',
  LAUNCH_DATE: 'launchDate',
  END_DATE: 'endDate',
};
